import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { AccessDeniedPage } from '@/pages/AccessDeniedPage'

export function ProtectedRoute() {
  const { token, loading, isStaff } = useAuth()

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-sm text-zinc-500">Verifying staff access…</p>
      </div>
    )
  }

  if (!token) {
    return <Navigate to="/login" replace />
  }

  if (!isStaff) {
    return <AccessDeniedPage />
  }

  return <Outlet />
}
